import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { Paths } from '@shared/AppRoutes';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { useAppNavigate } from '@shared/store';
import { Box, Stack, Typography } from '@mui/material';
import EventBusyIcon from '@mui/icons-material/EventBusy';

export const VisitListStatusIcon = ({
  isVisitOpen,
  clientId,
  visitId,
}: {
  isVisitOpen: boolean;
  clientId: string;
  visitId: string;
}) => {
  const { t } = useIntlTranslations();
  const navigate = useAppNavigate();

  const handleClick = () => {
    if (clientId) {
      navigate(Paths.visitDetail(clientId, visitId));
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        cursor: clientId ? 'pointer' : 'default',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {isVisitOpen ? (
        <Stack justifyContent="center" alignItems="center">
          <EventAvailableIcon sx={{ fontSize: '15px' }} color="success" />
          <Typography fontSize="0.6rem" color="#168960">
            {t('stock.closedVisit')}
          </Typography>
        </Stack>
      ) : (
        <Stack justifyContent="center" alignItems="center">
          <EventBusyIcon sx={{ fontSize: '15px' }} color="error" />
          <Typography fontSize="0.6rem" color="error">
            {t('stock.notClosedVisit')}
          </Typography>
        </Stack>
      )}
    </Box>
  );
};
